module.exports = __webpack_public_path__ + "img/pointer_icon.e6462a79.svg";